import palette from '../palette';

export default {
	gutterBottom: {
		marginBottom: 8,
		color: palette.color
	}
};
